export class Handler {
    constructor(status, trigger) {
        this.status = status;
        this.trigger = trigger;
        this.value = this.trigger.dataset.changeTrigger;
        this.totalCharaNum = document.querySelectorAll('[data-chara]').length;
        this.registerEvent();
    }

    registerEvent() {
        if (this.value === 'next') {
            this.trigger.addEventListener('click', this.setNext.bind(this));
        } else if (this.value === 'prev') {
            this.trigger.addEventListener('click', this.setPrev.bind(this));
        } else {
            this.trigger.addEventListener('click', this.setActiveIdx.bind(this));
        }
    }

    setActiveIdx(e) {
        const currentIdx = Number(e.currentTarget.dataset.charaIdx);
        if (this.status.activeIdx === currentIdx) return;
        this.status.activeIdx = currentIdx;
    }

    setNext() {
        if (this.status.activeIdx === this.totalCharaNum - 1) {
            this.status.activeIdx = 0;
            return;
        }
        this.status.activeIdx += 1;
    }

    setPrev() {
        if (this.status.activeIdx === 0) {
            this.status.activeIdx = this.totalCharaNum - 1;
            return;
        }
        this.status.activeIdx -= 1;
    }
}
